import React from "react";
import MuiTooltip from "@mui/material/Tooltip";

import InfoIcon from "@tiny/icons/generated/Info";
import { TooltipProps } from "./Tooltip.types";
import { useTooltipStyles, useStyles } from "./Tooltip.styles";
import { ClickAwayListener } from "..";
import { doNothing } from "../utils/eventHandlerUtils";

function Tooltip(props: TooltipProps) {
  const {
    color,
    title: titleProp,
    action,
    customContent = false,
    onClickAway = doNothing,
    ...other
  } = props;

  const tooltipClasses = useTooltipStyles(props);

  const classes = useStyles(props);

  const title = customContent ? (
    titleProp
  ) : (
    <>
      <InfoIcon className={classes.infoIcon} />
      {titleProp}
      {action && <div className={classes.action}>{action}</div>}
    </>
  );

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <MuiTooltip
        classes={tooltipClasses}
        arrow
        leaveTouchDelay={4000}
        title={title}
        disableInteractive={!action}
        enterTouchDelay={0}
        {...other}
      />
    </ClickAwayListener>
  );
}

export default Tooltip;
